import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserModalButtonDemo from 'src/games/demos/modalButtonComponentDemo/Main';

interface ModalButtonDemoProps extends PageProps<{}> {
}

class ModalButtonDemo extends React.Component<ModalButtonDemoProps> {
    constructor(props: ModalButtonDemoProps) {
        super(props);
        bindAllOfThis(this, ModalButtonDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserModalButtonDemo />
        </div>);
    }
}

export default ModalButtonDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/ModalButtonDemo.tsx